import db from './index';
import { META_MIGRATED } from './schema';
import {
	putZones,
	putPonds,
	putVisits,
	putImages,
	saveSingleton,
	setMeta,
	getMeta,
	refreshZoneIndex,
	bumpSince,
} from './repositories';
import config from 'config';

/**
 * Lit un fichier JSON local via la couche storage existante.
 */
function readJsonFile( filename )
{
	var deferred = $.Deferred();

	app.storage.read( 'data', filename ).done( function( text )
	{
		try
		{
			deferred.resolve( JSON.parse( text ) );
		}
		catch( e )
		{
			console.warn( 'migrate: parse fail', filename, e );
			deferred.resolve( null );
		}
	} ).fail( function()
	{
		deferred.resolve( null );
	} );

	return deferred.promise();
}

/**
 * Initialise le curseur since depuis les lignes migrées.
 */
function initSinceFromRows( table, rows )
{
	if( !_.isArray( rows ) || !rows.length )
	{
		return Promise.resolve();
	}

	var stamps = _.map( rows, function( row )
	{
		return row.deleted_at || row.updated_at;
	} );

	return bumpSince( table, stamps );
}

/**
 * Migration one-shot des blobs JSON vers Dexie.
 */
export function migrateFromJson()
{
	return getMeta( META_MIGRATED ).then( function( done )
	{
		// Déjà migré
		if( done )
		{
			return refreshZoneIndex();
		}

		console.log( '[db] migration JSON → Dexie…' );

		return Promise.all( [
			readJsonFile( config.file.zone ),
			readJsonFile( config.file.pond ),
			readJsonFile( config.file.visit ),
			readJsonFile( config.file.image ),
			readJsonFile( config.file.user ),
			readJsonFile( config.file.data ),
		] ).then( function( results )
		{
			var zones = results[0];
			var ponds = results[1];
			var visits = results[2];
			var images = results[3];
			var user = results[4];
			var data = results[5];
			var chain = Promise.resolve();

			// Data singleton
			if( data && _.isObject( data ) && !_.isArray( data ) )
			{
				chain = chain.then( function()
				{
					return saveSingleton( 'data', data );
				} );
			}

			// User singleton
			if( user && _.isObject( user ) && !_.isArray( user ) )
			{
				chain = chain.then( function()
				{
					return saveSingleton( 'user', user );
				} );
			}

			// Zones
			if( _.isArray( zones ) && zones.length )
			{
				chain = chain.then( function()
				{
					return putZones( zones ).then( function()
					{
						return initSinceFromRows( 'zones', zones );
					} );
				} );
			}

			// Mares
			if( _.isArray( ponds ) && ponds.length )
			{
				chain = chain.then( function()
				{
					return putPonds( ponds ).then( function()
					{
						return initSinceFromRows( 'ponds', ponds );
					} );
				} );
			}

			// Visites
			if( _.isArray( visits ) && visits.length )
			{
				chain = chain.then( function()
				{
					return putVisits( visits ).then( function()
					{
						return initSinceFromRows( 'visits', visits );
					} );
				} );
			}

			// Images (métadonnées)
			if( _.isArray( images ) && images.length )
			{
				chain = chain.then( function()
				{
					return putImages( images ).then( function()
					{
						return initSinceFromRows( 'images', images );
					} );
				} );
			}

			return chain.then( function()
			{
				return setMeta( META_MIGRATED, true );
			} ).then( function()
			{
				console.log( '[db] migration OK' );
				return refreshZoneIndex();
			} );
		} );
	} );
}

/**
 * Ouvre la base et lance la migration si besoin.
 */
export function openDatabase()
{
	return db.open().then( function()
	{
		return migrateFromJson();
	} );
}
